import {BaseProps} from "../../types";
import {ConfigProvider, Select} from "antd";
import {useMemo} from "react";
import {languageFlags, fallback} from './data'

type LanguageSwitcherProps = {
  current: string
  options: { label: string; value: string }[]
}

export default function LanguageSwitcher(props: BaseProps<LanguageSwitcherProps>) {
  const { current = 'vi', options = [] } = props.data || {}

  const onLanguageChange = (language: string) => {
    const targetUrl = window.location.pathname
    if (targetUrl === '/') return window.location.pathname = `/${language}`
    const languageRegex1 = new RegExp(`^\/${current}\/?$`)
    if (languageRegex1.test(targetUrl)) {
      return window.location.pathname = `/${language}`
    }
    const languageRegex = new RegExp(`^\/(${current})\/`)
    window.location.pathname = targetUrl.replace(languageRegex, `/${language}/`)
  }

  const languageLabel = useMemo(() => {
    const labelText = languageFlags[current]
    return labelText ? labelText : fallback
  }, [current])

  if (!options || options.length === 0) return null

  return (
    <div className={'text-[16px]'}>
      <ConfigProvider
        theme={{
          components: {
            Select: {
              optionSelectedColor: '#000000',
              colorText: '#ffffff'
            }
          }
        }}
      >
        <Select
          popupMatchSelectWidth={false}
          defaultValue={current}
          variant={'borderless'}
          onChange={onLanguageChange}
          options={options}
          labelRender={(label) => {
            return <div className={'text-[32px]'}>{languageLabel}</div>
          }}
          optionRender={(oriOption, info) => {
            return <div className={'text-black'}>{oriOption.label}</div>
          }}
          suffixIcon={null}
        />
      </ConfigProvider>
    </div>
  )
}